import { type GridRenderEditCellParams } from "@mui/x-data-grid";
import { type FC } from "react";
import { StagelessAction, type WorkPacket } from "src/types/work-packets";
import EditableAutocompleteCell from "../EditableAutocompleteCell";
import { abandonedReasonOptions } from "src/pages/UserDashboard/Cases/api/constants";
import { getStagelessActionValue } from "../../mappers";

export const AbandonedReasonEdit: FC<GridRenderEditCellParams<WorkPacket>> = props => {
  const isAbandoned = props.row.currentAction === getStagelessActionValue(StagelessAction.Abandoned);
  return (
    <EditableAutocompleteCell
      {...props}
      disabled={!isAbandoned}
      options={abandonedReasonOptions}
      errorTooltipPlacement="right"
    />
  );
};
